import { ApiKeyAuthProvider } from './ApiKeyAuthProvider';
import { CookieAuthProvider } from './CookieAuthProvider';
import type { AuthProvider, AuthType } from './AuthProvider';

interface CreateAuthProviderProps {
  authType: AuthType;
  apiKey: string;
  apiSecret: string;
}

export function createAuthProvider({
  authType,
  apiKey,
  apiSecret,
}: CreateAuthProviderProps): AuthProvider {
  switch (authType) {
    case 'api-key':
      return new ApiKeyAuthProvider({ apiKey, apiSecret });

    case 'cookie':
      return new CookieAuthProvider();

    default:
      throw new Error(`Unsupported authType '${authType}'.`);
  }
}
